import { isNil, isObject } from 'lodash'

export function isEmpty(value: unknown): boolean {
  if (Array.isArray(value)) {
    return value.length === 0
  }

  if (isObject(value)) {
    return isEmpty(Object.keys(value))
  }

  return isNil(value) || value === ''
}
